import axios from "axios";

// Prod: same-origin "/api" (Firebase Hosting rewrites /api/** → Cloud Run).
// Dev:  set REACT_APP_BACKEND_URL=http://localhost:8001 in frontend/.env
// If the var is missing or empty, fall back to same-origin — never hard-code
// localhost into a production bundle again.
const RAW_BASE = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
export const API = RAW_BASE ? `${RAW_BASE}/api` : "/api";

export const api = axios.create({ baseURL: API });

// Attach bearer token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("neon_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && e.msg) || JSON.stringify(e)).join(", ");
  return String(d);
}
